import script from "./img-radio-group.vue?vue&type=script&setup=true&lang=js"
export * from "./img-radio-group.vue?vue&type=script&setup=true&lang=js"

import "./img-radio-group.vue?vue&type=style&index=0&id=67a20af6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67a20af6"]])

export default __exports__